


import { Routes, RouterModule } from '@angular/router';
import { ModuleComponent } from './module.component';

const routes: Routes = [
    {
        path: '',
        component: ModuleComponent
    },
];

export const ModuleRoutes = RouterModule.forChild(routes);
